
import * as L from 'leaflet';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ICircleOptions } from '../models/ICircleOptions';

@Component({ name: 'LeafletMapCircle' })
export default class LeafletMapCircle extends Vue {
  @Prop() map!: L.Map;
  @Prop() layer!: L.LayerGroup | L.Map;
  @Prop() circle!: ICircleOptions;

  mapCircle = null as L.Circle | null;

  destroyed() {
    this.mapCircle?.remove();
  }

  mounted() {
    this.mapCircle = new L.Circle(this.circle.Center, this.getStyleOptions()).addTo(this.map).bringToFront();
  }

  @Watch('circle')
  onCircleChange() {
    if (this.mapCircle) {
      this.mapCircle.setLatLng(this.circle.Center);
      this.mapCircle.setRadius(this.circle.Radius);
      this.mapCircle.setStyle(this.getStyleOptions());
    }
  }

  private getStyleOptions() {
    return {
      radius: this.circle.Radius,
      fill: this.circle.Fill ?? false,
      fillColor: this.circle.Fill ? this.circle.Color : undefined,
      fillOpacity: 1,
      weight: 1,
      color: this.circle.Color
    };
  }
}
